<template>
  <section v-show="active" class="app-modal__section">
    <div class="app-modal__section-head">
      <h4>{{ text.modal.form.classification.title }}</h4>
      <p>{{ text.modal.form.classification.subtitle }}</p>
    </div>

    <div class="app-modal__grid two-columns">
      <div class="app-modal-field full-width">
        <div class="supplier-specialties__header-row">
          <span class="supplier-specialties__label">{{ text.modal.form.classification.fields.specialties }}</span>
          <button type="button" class="supplier-specialties__link" @click="$emit('toggle-new-specialty')">
            {{ text.modal.form.classification.actions.newSpecialty }}
          </button>
        </div>

        <multiselect
          v-model="form.specialties"
          :options="specialtyOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :max-height="240"
          :placeholder="text.modal.form.classification.placeholders.specialties"
          class="app-modal-select app-select supplier-specialties-select"
        >
          <template #noResult><span>{{ text.common.noOptionAvailable }}</span></template>
          <template #noOptions><span>{{ text.common.noOptionAvailable }}</span></template>
        </multiselect>

        <div v-if="showNewSpecialtyInput" class="supplier-specialties__inline">
          <label class="app-modal-field">
            <span>{{ text.modal.form.classification.fields.newSpecialtyName }}</span>
            <input
              :value="newSpecialtyName"
              type="text"
              class="form-control"
              :placeholder="text.modal.form.classification.placeholders.newSpecialtyName"
              @input="$emit('update:new-specialty-name', $event.target.value)"
            />
          </label>

          <div class="supplier-specialties__actions">
            <button type="button" class="btn btn-light" @click="$emit('cancel-new-specialty')">{{ text.actions.common.cancel }}</button>
            <button
              type="button"
              class="app-header-btn app-header-btn--primary"
              :disabled="creatingNewSpecialty || String(newSpecialtyName || '').trim() === ''"
              @click="$emit('save-new-specialty')"
            >
              {{ text.modal.form.classification.actions.saveAndUseSpecialty }}
            </button>
          </div>
        </div>
      </div>

      <div class="app-modal-field full-width">
        <span>{{ text.modal.form.classification.fields.area }}</span>
        <multiselect
          v-model="form.areaOption"
          :options="areaOptions"
          track-by="value"
          label="label"
          :show-labels="false"
          :searchable="true"
          :allow-empty="true"
          :max-height="240"
          :placeholder="text.modal.form.classification.placeholders.area"
          class="app-modal-select app-select"
        >
          <template #noResult><span>{{ text.common.noOptionAvailable }}</span></template>
          <template #noOptions><span>{{ text.common.noOptionAvailable }}</span></template>
        </multiselect>
      </div>
    </div>
  </section>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('suppliers');

export default {
  name: 'SupplierSectionClassification',
  props: {
    active: { type: Boolean, default: false },
    form: { type: Object, required: true },
    areaOptions: { type: Array, default: () => [] },
    specialtyOptions: { type: Array, default: () => [] },
    showNewSpecialtyInput: { type: Boolean, default: false },
    newSpecialtyName: { type: String, default: '' },
    creatingNewSpecialty: { type: Boolean, default: false },
  },
  emits: [
    'toggle-new-specialty',
    'save-new-specialty',
    'cancel-new-specialty',
    'update:new-specialty-name',
  ],
  data() {
    return {
      text,
    };
  },
};
</script>

<style scoped>
.supplier-specialties__link {
  border: 0;
  background: transparent;
  color: #0070cd;
  font-size: 12px;
  font-weight: 600;
  padding: 0;
  display: inline-block;
}

.supplier-specialties__header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.supplier-specialties__label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}

.supplier-specialties__inline {
  margin-top: 10px;
  border: 1px dashed rgba(153, 152, 153, 0.45);
  border-radius: 8px;
  padding: 12px;
  display: grid;
  gap: 10px;
}

.supplier-specialties__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.supplier-specialties__actions .app-header-btn {
  min-height: 38px;
  padding: 0 16px;
  border-radius: 7px;
}

.supplier-specialties-select :deep(.multiselect__tags),
.supplier-specialties-select :deep(.multiselect-tags) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  min-height: 36px !important;
  height: auto !important;
  padding: 10px 36px 10px 8px !important;
  overflow: hidden;
}

.supplier-specialties-select :deep(.multiselect__tags-wrap) {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  column-gap: 6px;
  row-gap: 6px;
  width: 100%;
  margin: 0;
  overflow: hidden;
}

.supplier-specialties-select :deep(.multiselect__tag),
.supplier-specialties-select :deep(.multiselect-tag) {
  background: #e9eff8;
  color: #334155;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  min-height: 26px;
  padding: 0 24px 0 10px;
  margin: 0;
}

.supplier-specialties-select :deep(.multiselect__tag-icon:after),
.supplier-specialties-select :deep(.multiselect-tag-remove) {
  color: #64748b;
  line-height: 1;
  margin: 0;
}
</style>
